exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selling-container[data-v-23da9390]{min-height:80vh}\n", ""]);

// exports
